<template>
  <div class="HowItWorks">
    <h1>How Does It Work?</h1>
    <div class="imageholder">
      <div class="Desc">
        <div class="descriptions">
          <div class="left top"></div>
          <div class="right">
            <img src="../assets/Home/HowSection/subscribe.png" class="avators">
            <h1>Decide It</h1>
            <p>Need it one time or need it daily.</p>
          </div>
        </div>
        <div class="descriptions">
          <div class="right middle"></div>
          <div class="right">
            <img class="headIcons" src="../assets/Home/HowSection/SetIt.png" alt="">
            <h1 class="middleHeading">Set It</h1>
            <p class="middleDesc">The litres you want and the time you want.</p>
          </div>
        </div>
        <div class="descriptions">
          <div class="left bottom"></div>
          <div class="right">
            <img class="headIcons" src="../assets/Home/HowSection/GetIt.png" alt="">
            <h1>Get It</h1>
            <p>Have it delivered to your doorstep.</p>
          </div>
        </div>
      </div>
      <img class="timeline" src="../assets/Home/HowSection/how_does_it_work.png" alt="" />
    </div>
    <center  @click="scrollTo('nav')"><router-link to="/order"><button>Get Your Fresh Milk Now!</button></router-link></center>
  </div>
</template>

<script>
export default {
  methods:{
    scrollTo(id) {
      const element = document.getElementById(id);
      element.scrollIntoView({ behavior: "smooth" });
    },
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },
  }
};
</script>

<style scoped>
.HowItWorks {
  padding: 70px 0px 70px 0px;
  /* height: 1495px; */
  width: 100%;
  background-color: #0077b6;
}
.imageholder {
  position: relative;
  /* background-color: lawngreen; */
  display: grid;
  contain: content;
  /* justify-items: center; */
}
.headIcons{
  display: none;
  height: 200px;
}
img.avators {
  display: none;
}
img.timeline {
  margin: auto;
  height: 1040px;
  width: 793px;
}
.right h1{
text-align: left;
}
h1.middleHeading, p.middleDesc{
  text-align: right;
}
h1 {
  /* width: 255px; */
  color: #fff;
  font-size: 36px;
  font-weight: 700;
  line-height: 47px;
  text-align: center;
}
.right p{
  width: 220px;
  color: #FFF;
  font-family: "DM Sans";
  font-size: 20px;
  line-height: 26px;
}
button {
  margin: 100px 0px 0px 0px;
  background-color: transparent;
  box-sizing: border-box;
  height: 60px;
  width: 355px;
  border-radius: 60px;
  border: 2px solid #fff;
  color: #fff;
  font-size: 20px;
  font-weight: 500;
  line-height: 26px;
  text-align: center;
}
.Desc {
  position: absolute;
  top: 100xp;
  left: 30%;
  /* background-color: #ff634755; */
  width: 40%;
  max-width: 700px;
  height: 130%;
  margin: auto;
  display: grid;
}
.descriptions {
  display: flex;
  /* background-color: teal; */
  margin: 10px;
  height: 150px;
}
.left {
  width: 100%;
}
.bottom {
  background-color: tomato;
  margin-bottom: auto;
}
@media screen and (max-width:720px){
  img.timeline {
  display: none;
}
img.avators {
  display: unset;
  width: 90%;
}
.headIcons{
  display: unset;
}
.Desc {
  position: unset;
  /* background-color: #ff634755; */
  width: 90%;
  max-width: 700px;
  height: unset;
  margin: auto;
  display: grid;
}
.descriptions {
  display: block;
  margin: 10px;
  height: unset;
  text-align: center;
}
.right h1{
  text-align: center;
  /* background-color: teal; */
}
h1.middleHeading, p.middleDesc{
  text-align: center;
}
h1 {
  color: #fff;
  text-align: center;
}
.right p{
  margin: unset;
  width: 90%;
}
}
</style>